export enum MiProModules {
    Consultations = "Consultation History (Clinical Notes) Module",
    Diary = "Diary Module",
    Prescriptions = "Prescriptions Module",
    Tues = "TUEs Module",
    Referrals = "Referrals Module",
    Investigations = "Investigations Module",
    Raven = "Raven",
    FunctionalGut = "Functional Gut Testing",
    GlobalDRO = "GlobalDRO",
    Forms = "Forms Module",
    EventsModule = "Events Module",
    Reporting = "Reporting Module",
    NHS = "NHS"
}
